import { memo } from 'react';

import CheckmarkDuotoneIconSVG from '@/assets/checkmark-duotone-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ICheckmarkDuotoneIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={CheckmarkDuotoneIconSVG} {...props} />
);

export const CheckmarkDuotoneIcon = memo(ICheckmarkDuotoneIcon) as typeof ICheckmarkDuotoneIcon;
